export default [
  { name: 'whatsapp', icon: 'whatsapp' },
  { name: 'telegram', icon: 'telegram' },
  { name: 'facebook', icon: 'facebook-official' },
  { name: 'instagram', icon: 'instagram' },
  { name: 'sms', icon: 'commenting-o' },
]

export const channelName = {
  chatweb: { name: 'channels_chatweb', hub: 'wall', order: 0 },
  chatmail: { name: 'channels_chatmail', hub: 'chatmail', order: 1 },
  whatsapp_whatsapp: { name: 'channels_whatsapp_whatsapp', hub: 'whatsapp', order: 2 },
  whatsapp: { name: 'channels_twilio_whatsapp', hub: 'twilio', order: 3 },
  instagram: { name: 'channels_instagram', hub: 'instagram', order: 4 },
  facebook: { name: 'channels_facebook', hub: 'facebook', order: 5 },
  android: { name: 'channels_android', hub: 'wall', order: 6 },
  ios: { name: 'channels_ios', hub: 'wall', order: 7 },
  sms: { name: 'channels_sms', hub: 'twilio', order: 8 },
  telegram: { name: 'channels_telegram', hub: 'telegram', order: 9 },
  android_api: { name: 'channels_android_api', hub: 'wall', order: 10 },
  ios_api: { name: 'channels_ios_api', hub: 'wall', order: 11 },
  wall: { name: 'channels_wall', hub: 'wall', order: 12 },
  chatweb_api: { name: 'channels_chatweb_api', hub: 'wall', order: 13 },
  imap: { name: 'channels_chatmail', hub: 'chatmail', order: 0, notShow: true },
  imap_yahoo: { name: 'channels_chatmail', hub: 'chatmail', order: 0, notShow: true },
  imap_aol: { name: 'channels_chatmail', hub: 'chatmail', order: 0, notShow: true },
  imap_icloud: { name: 'channels_chatmail', hub: 'chatmail', order: 0, notShow: true },
  gmail: { name: 'channels_chatmail', hub: 'chatmail', order: 0, notShow: true },
  outlook: { name: 'channels_chatmail', hub: 'chatmail', order: 0, notShow: true },
  office360: { name: 'channels_chatmail', hub: 'chatmail', order: 0, notShow: true },
  exchange: { name: 'channels_chatmail', hub: 'chatmail', order: 0, notShow: true },
}

// Canales a mostrar en la pantalla de creación.
export const channelToAdd = {
  chatweb: {
    name: 'channels_chatweb',
    hub: 'wall',
    key: 'chatweb',
    order: 0
  },
  chatmail: { name: 'channels_chatmail', hub: 'chatmail', key: 'chatmail', order: 1 },
  whatsapp_whatsapp: { name: 'channels_whatsapp_whatsapp', hub: 'whatsapp', key: 'whatsapp', order: 2 },
  whatsapp: { name: 'channels_whatsapp', hub: 'twilio', key: 'whatsapp', order: 3 },
  instagram: { name: 'channels_instagram', hub: 'instagram', key: 'instagram', order: 4 },
  facebook: { name: 'channels_facebook', hub: 'facebook', key: 'facebook', order: 5 },
  android: { name: 'channels_android', hub: 'wall', key: 'android', order: 6 },
  ios: { name: 'channels_ios', hub: 'wall', key: 'ios', order: 7 },
  sms: { name: 'channels_sms', hub: 'twilio', key: 'sms', order: 8 },
  telegram: { name: 'channels_telegram', hub: 'telegram', key: 'telegram', order: 9 },
  wall: { name: 'channels_wall', hub: 'wall', key: 'wall', order: 12 }
}

export const chatmailProviders = ['imap', 'imap_aol', 'imap_yahoo', 'imap_icloud', 'gmail', 'outlook', 'office360', 'exchange']

export const getChannelKey = (key) => chatmailProviders.includes(key) ? 'chatmail' : key

export const isChatmail = (key) => chatmailProviders.includes(key) ? true : false

export const iconText = [
  { label: 'channels_links_icon_text', value: 'iconText' },
  { label: 'channels_links_only_icon', value: 'icon' },
]

export const sizeButton = [
  { label: 'channels_links_size_button_small', value: 'small' },
  { label: 'channels_links_size_button_medium', value: 'medium' },
  { label: 'channels_links_size_button_normal', value: 'normal' },

]

export const staticFloating = [
  { label: 'channels_links_static', value: 'static' },
  { label: 'channels_links_floating', value: 'floating' },
]

export const offlineChannels = ['whatsapp', 'facebook', 'instagram', 'chatweb']

export const CHANNELINCHAT = ['inchat', 'inChat']

export const typeInchat = ['channel']